var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.823,
    height: 16.84,
    viewBox: "0 0 10.823 16.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#1291d9;stroke-linecap:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD654\\uC0B4\\uD45C_\\uC67C\\uCABD_\\uD30C\\uB791\\uC0C9",
    transform: "translate(1.412 1.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_back",
    transform: "translate(8 14) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_17",
    d: "M0 6.981L8 0",
    className: "cls-1",
    transform: "translate(0 7.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_44",
    d: "M0 0l7.921 7.035",
    className: "cls-1",
    transform: "translate(0.079 -0.017)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a81f8c25.svg";
export { ForwardRef as ReactComponent };